// extracted by mini-css-extract-plugin
export default {"LocSubscribersField":"_5UWCaIj6NRBR0Cn6g7V1YGdwO3bSPTFE8XCVmFNsOqB","addRow":"f9nDC-M-xZ6qPYDfr2ZZViF6bXOi2Q0JH2GLgIVGp3P"};